import {RichTextField} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next'
import {PrismicRichText} from '@prismicio/react'
import Link from 'next/link'
import {linkResolver} from 'prismicio'
import {Fragment, memo} from 'react'
import {removeNonAlphanumeric} from 'slices/CustomerStoryContent/utils'

export const RTEComponent = memo(({field}: {field: RichTextField}) => {
  return (
    <PrismicRichText
      components={{
        heading2: ({children, node}) => (
          <h2
            className="mb-6 scroll-mt-32 text-32 leading-10 -tracking-common text-1e2a25 sm:mb-8 md:mb-10 lg:scroll-mt-16 lg:text-40 lg:leading-11"
            id={removeNonAlphanumeric(node.text)}
          >
            {children}
          </h2>
        ),
        heading3: ({children}) => <h3 className="mb-4 text-24 font-medium leading-7 text-1e2a25">{children}</h3>,
        heading4: ({children}) => <h4 className="text-h4 max-w-[600px] text-moss-black">{children}</h4>,
        heading6: ({children}) => (
          <blockquote className="mb-4 px-5 py-2.5 text-28 leading-8 text-232f2a md:pl-15">{children}</blockquote>
        ),
        paragraph: ({children}) => <p className="text-body pb-4 text-grey-550">{children}</p>,
        hyperlink: ({children, node}) => (
          <Link
            className="text-456e5e underline transition-colors duration-150 hover:text-6c9d8b"
            href={linkResolver(node.data)}
            {...(node.data.link_type === 'Web' && node.data.target && {target: node.data.target})}
          >
            {children}
          </Link>
        ),
        image: ({node, key}) => {
          const img = (
            <PrismicNextImage
              className="mb-12 mt-8 rounded-2xl lg:mb-16 lg:mt-12"
              field={node}
              data-copyright={node.copyright ? node.copyright : undefined}
            />
          )

          return (
            <Fragment key={key}>{node.linkTo ? <Link href={linkResolver(node.linkTo)}>{img}</Link> : img}</Fragment>
          )
        },
        preformatted: ({text}) => {
          return <div id={text} />
        },
        em: ({children}) => <span className="text-body-bold-s text-grey-300">{children}</span>,
        list: ({children}) => <ul className="mt-[-16px] list-none flex-col pt-6">{children}</ul>,
        listItem: ({children}) => (
          <li className="mb-2 flex gap-2">
            <div className="mt-[9px] h-[5px] w-[5px] min-w-[5px] rounded-[1px] bg-moss-grey-300" />
            <p className="text-body pb-4 text-grey-550">{children}</p>
          </li>
        ),
        strong: ({children}) => <span className="font-medium text-black">{children}</span>,
      }}
      field={field}
    />
  )
})
